import request from './request';

const OrderStatusService = {
  getAll: (params) => request.get('dashboard/admin/order-statuses', { params }),
  getById: (id) => request.get(`dashboard/admin/order-statuses/${id}`),
  get: (params) => request.get('rest/order-statuses', { params }),
  update: (id, data) => request.put(`dashboard/admin/order-statuses/${id}`, data),
  deleteById: (id) => request.delete(`dashboard/admin/order-statuses/${id}`),
  status: (id) => request.post(`dashboard/admin/order-statuses/${id}/active`),
  create: (data) => request.post('dashboard/admin/order-statuses', data),
};

export default OrderStatusService;
